<template>
    <PortalAuth>
        <CContainer class="d-flex content-center min-vh-100">
            <CRow>
                <CCol>
                    <CCardGroup>
                        <CCard class="p-4 left-card">
                            <CCardBody>
                                <CForm @submit.prevent="onSubmit">
                                    <h1 style="text-align:center">Login</h1>
                                    <p class="text-muted" style="text-align:center">Sign In to your account</p>
                                    <CInput
                                        v-model="email"
                                        placeholder="Email"
                                        type="email"
                                        name="email"
                                        required
                                    >
                                        <template #prepend-content>
                                            <!--suppress HtmlUnknownTag -->
                                            <CIcon name="cilEnvelopeOpen"/>
                                        </template>
                                    </CInput>
                                    <CInput
                                        v-model="password"
                                        placeholder="Password"
                                        type="password"
                                        autocomplete="off"
                                        required
                                    >
                                        <template #prepend-content>
                                            <!--suppress HtmlUnknownTag -->
                                            <CIcon name="cilLockLocked"/>
                                        </template>
                                    </CInput>
                                    <FormErrors :errors="errors"/>
                                    <CRow class="login-group">
                                        <CCol sm="6" class="text-left">
                                            <CButton color="info" class="px-4 login-btn" type="submit" :disabled="this.graphqlLoadingFlag">Login
                                            </CButton>
                                        </CCol>
                                        <CCol sm="6" class="text-right login-text">
                                            <CButton :to="{name: 'forgot-password'}" color="link" class="px-0">Forgot
                                                password?
                                            </CButton>
                                        </CCol>
                                    </CRow>
                                    <p class="mt-3" style="text-align:center">By continuing you confirm that you are older than 18 and agree to
                                        <br>
                                        <CLink :to="{name: 'terms-of-use'}" style="color:#3c4b64;font-weight:600" target="_blank">Terms of Use</CLink><!--
                                        -->,
                                        <CLink :to="{name: 'privacy-policy'}" style="color:#3c4b64;font-weight:600" target="_blank">Privacy Policy
                                        </CLink>
                                    </p>
                                </CForm>
                            </CCardBody>
                        </CCard>
                        <CCard
                            color="facebook"
                            text-color="white"
                            class="text-center py-5 right-card"
                            body-wrapper
                        >
                            <h2>Sign up</h2>
                            <p>It’s easy to refine your technique and check for technical errors. No credit cards are
                                required.</p>
                            <CButton v-if="nextIsTraining"
                                     color="info"
                                     class="active mt-3"
                                     :to="{name: 'signup', 'params': {'tag': 'by-training'}, query: $route.query}"
                            >
                                Register Now!
                            </CButton>
                            <CButton v-else
                                     color="info"
                                     class="active mt-3"
                                     @click="goToSignUpUrl"
                            >
                                Register Now!
                            </CButton>

                            <Toaster :toasts="toasts"/>
                        </CCard>
                    </CCardGroup>
                </CCol>
            </CRow>
        </CContainer>
    </PortalAuth>
</template>

<script>
    import {
        getLoginMutation,
        onSubmitAuthHandler,
        getProcessedAuthResponseErrorsFlat,
        checkNextIsTraining
    } from '@/scripts/auth-utils'
    import PortalAuth from '@/components/layouts/PortalAuth'
    import FormErrors from '@/components/FormErrors'
    import router from "@/plugins/router";
    import Toaster from "@/components/Toaster.vue";

    export default {
        components: {Toaster, PortalAuth, FormErrors},
        data() {
            return {
                email: '',
                password: '',
                errors: [],
                graphqlLoadingFlag: false,
                nextIsTraining: checkNextIsTraining(),
                toasts: []
            }
        },
        methods: {
            async onSubmit() {
                let mutation = getLoginMutation(this.email.toLowerCase(), this.password)
                await onSubmitAuthHandler(this, mutation,
                    (errors, scope) => scope.errors = getProcessedAuthResponseErrorsFlat(errors),
                    'feed')
            },
            goToSignUpUrl() {
                router.push({name: 'signup', params: {tag: 'from-main'}})
            },
            checkActivationCode() {
                const query = this.$router?.currentRoute?.query;
                const code = query && query['activation-code'] ? query && query['activation-code'] : null;
                if (code === '0') {
                    this.toasts.push({
                        success: true,
                        content: 'Your email has been verified. Account activated.'});
                } else if (code === '1') {
                    this.toasts.push({
                        success: false,
                        content: 'An error occured during the email activation.'
                    });
                } else if (typeof code === 'string') {
                    this.toasts.push({
                        success: false,
                        content: code
                    });
                }
            },
            checkActivateCode() {
                const query = this.$router?.currentRoute?.query;
                const code = query && query['email-activation'] ? query && query['email-activation'] : null;
                if (code) {
                    this.toasts.push({
                        success: true,
                        content: 'We have sent a link to your email to activate this account.'
                    });
                }
            }
        },
        mounted() {
            this.checkActivateCode()
            this.checkActivationCode()
        }
    }
</script>
<style lang="scss">
    .form-group {
        position: relative;

        .invalid-feedback {
            position: absolute;
            margin-top: 0;
            bottom: -13px;
            text-align: left;
        }
    }

    @media screen and (max-width: 576px) {
        .login {
            &-btn {
                width: 100%;
            }
        }
        .card-group > .left-card {
            margin-bottom: 0 !important;
            border-bottom-left-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
        }
        .card-group > .right-card {
            border-top-left-radius: 0 !important;
            border-top-right-radius: 0 !important;
            margin-bottom: 80px !important;
        }
    }
</style>
